module.exports = FormData;


//////////////////
// WEBPACK FOOTER
// ../js/~/isomorphic-form-data/lib/browser.js
// module id = 653
// module chunks = 0